export default "__VITE_ASSET__B$cbpkjg__"